import { faBarcode } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _trim from 'lodash/trim';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react'
import BarcodePanel from 'src/components/barcode-panel';
import Feature from 'src/components/feature';
import FeaturesContext from 'src/context/FeaturesContext';
import useActionPanelStore from 'src/stores/useActionPanelStore';
import useBarcodePanelStore from 'src/stores/useBarcodePanelStore';
import { FEATURES, isFeatureEnabled } from 'src/utils/features';

const RecordBuild = ({ handleStartBuild }) => {
  const {
    openActionPanel,
    closeActionPanel,
  } = useActionPanelStore();

  const {
    scannedBarcodeValue,
    setScannedBarcodeValue,
    resetBarcodeValue,
  } = useBarcodePanelStore();

  const { features } = useContext(FeaturesContext);
  const isValidationEnabled =
    isFeatureEnabled(features, FEATURES.GE_AEROSPACE_CUSTOMIZATIONS) &&
    isFeatureEnabled(features, FEATURES.MATERIAL_MANAGEMENT);

  const [inputError, setInputError] = useState('');

  const handleOpenExternalBuildIdBarcodeScanner = () => {
    resetBarcodeValue();
    openActionPanel({
      title: 'Scan Barcode',
      stack: true,
      content: <BarcodePanel
        placeholder="Scan External Build ID"
        instructionText="Please scan or type the barcode" />,
    });
  };

  const handleConfirm = () => {
    if (isValidationEnabled && !_trim(scannedBarcodeValue)) {
      setInputError('This field is required.');
      return;
    }

    setInputError('');

    handleStartBuild(scannedBarcodeValue)
  }

  return (
    <div>
      <label>
        <p>Please record the Build ID for the currently active build.</p>
        <p className="mb0">When the build is complete, you will be able to process the Dose, Overflow, and Build Modules at the MHS to calculate the amount of powder reclaimed and consumed by the build process.</p>
        <p className="mb0">You will then be able to use the modules to complete future print jobs.</p>
      </label>

      <Feature featureName={FEATURES.EXTERNAL_BUILD_ID}>
        <div className="input-group mt-4 d-flex align-items-center">
          <input
            name="storedAmount"
            value={scannedBarcodeValue}
            type="text"
            aria-label="External Build ID"
            placeholder="Enter Build ID"
            className={`form-control ${isValidationEnabled && inputError ? 'is-invalid' : ''}`}
            required={isValidationEnabled}
            onChange={(event) =>
              setScannedBarcodeValue({ scannedBarcodeValue: event.target.value })}
          />
          <button
            type="button" className="btn btn-link btn-sm barcode-scan-btn"
            onClick={handleOpenExternalBuildIdBarcodeScanner}
          >
            <FontAwesomeIcon icon={faBarcode} className="spacer-left" />
          </button>
        </div>
        {isValidationEnabled && inputError && (
          <div className="invalid-feedback d-block mb-4">{inputError}</div>
        )}
      </Feature>

      <button
        type='button'
        className='btn btn-lg btn-primary action-btn btn-block mt60'
        onClick={handleConfirm}
      >
        Confirm
      </button>
      <button type='button' className='btn btn-lg btn-block' onClick={closeActionPanel}>
        Cancel
      </button>
    </div>
  )
}

RecordBuild.propTypes = {
  handleStartBuild: PropTypes.func.isRequired,
}

export default RecordBuild;
